import { I18N } from '@/app'
import { createForm, yup } from '@codeleap/common'

import { aboutJobForm } from './aboutJob'
import { aboutYouForm } from './aboutYou'
import { signupForm } from './signup'

const MIN = 6
const MAX = 31
export const editProfileForm = (removePromptFields = false) => {
  const signup = signupForm()
  const aboutYou = aboutYouForm()
  const aboutJob = aboutJobForm()

  const fields = {
    email: signup.config.email,
    display_name: {
      type: 'text',
      label: I18N.t('form.label.screenName'),
      validate: yup
        .string()
        .required(I18N.t('form.validations.required'))
        .trim(I18N.t('form.validations.required'))
        .min(MIN, I18N.t('form.validations.min', { min: MIN }))
        .max(MAX, I18N.t('form.validations.max', { max: MAX }))
        .verifyProfanity(),
      placeholder: I18N.t('form.placeholder.screenName')
    },
    name: signup.config.name,
    organization: aboutJob.config.organization,
    department: aboutJob.config.department,
    seniority: aboutJob.config.seniority,
    inbound_source: aboutYou.config.inbound_source,
    inbound_source_details: aboutYou.config.inbound_source_details,
    gender: aboutYou.config.gender,
    country: aboutYou.config.country,
    climate_priority: aboutYou.config.climate_priority,
    learning_motivations: aboutYou.config.learning_motivations,
    confidence_at_work: aboutYou.config.confidence_at_work,
    satisfaction_at_work: aboutYou.config.satisfaction_at_work,
    receive_marketing_email: signup.config.receive_marketing_email,
    linkedin_url: {
      type: 'text',
      label: I18N.t('form.label.linkedinUrl'),
      placeholder: I18N.t('form.placeholder.linkedinUrl'),
      validate: yup
        .string()
        .transform(originalValue => (originalValue === '' ? null : originalValue))
        .nullable()
        .max(4000, I18N.t('SearchOrganisations.registerModal.urlMax', { max: 4000 }))
        .matches(
          /(https?:\/\/)?(?:www\.)?linkedin\.com(?:\\|\/)in(?:\/[a-zA-Z0-9-]+)?/,
          I18N.t('form.validations.invalidUrl')
        )
    }
  }

  if (removePromptFields) {
    delete fields.inbound_source
    delete fields.inbound_source_details
    delete fields.climate_priority
    delete fields.satisfaction_at_work
    delete fields.receive_marketing_email
  }

  return createForm('editProfile', fields as any)
}
